define.alias("shared/components/shared/post/secondary/caption-writer/credit-purchase", "media/components/shared/post/secondary/caption-writer/credit-purchase");